/* global Sentry */

CF = {};

(function() {
	var parts = $._loc.hostname.split('.');

	$.env({
		production: function() {
			return parts[0] === 'www' && parts[2] === 'com';
		},
		staging: function() {
			return parts[1] === 'codeqa';
		}
	});

	if (typeof Sentry !== 'undefined') {
		Sentry.init({
			autoSessionTracking: false,
			environment: $.env(),
			release: $.get('versions.core'),
			allowUrls: [
				/(.+)\.(calfaucets|codeqa)\.com/
			],
			ignoreErrors: [
				'AbortError: Fetch is aborted',
				'Error: Unspecified error.',
				'Illegal invocation'
			]
		});
	}
})();